import { GeneralService } from './../../../../shared/services/general.service';
import { SessionStateService } from './../../../../core/services/session-state.service';
import { Component, OnInit, Input, Inject } from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss']
})
export class SnackBarComponent implements OnInit {
  houseName: string;
 message: string;

  constructor(
    private sessionStateService: SessionStateService, @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {
    this.message = data
    this.houseName = this.sessionStateService.getHouse().name;
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/layouts/gui-layout/sidebar-layout/snack-bar/snack-bar.component.ts